import defaultConfig from '../config/configDefault';
import { getCookie } from '../util/cookieParser';

// Node: Should always be synced with locales.js (server)
export const LOCALE_CODE = {
  // Dutch - Netherlands
  NL_NL: 'nl-NL',
  // English - United States
  EN_US: 'en-US',
};

export const LANGUAGE_CODES =
  process.env.REACT_APP_ENV === 'production' ? [LOCALE_CODE.NL_NL] : Object.values(LOCALE_CODE);

// The language is prepended to every url path
export const LANG_URL_PARAM = `:lang(${LANGUAGE_CODES.join('|')})?`;
export const getLocaleFromUrl = url => {
  const cookieLocale = getCookieLocale();
  const browserLocale = getBrowserLocale();

  const localePriority = cookieLocale || browserLocale || defaultConfig.localization.locale;

  if (!url && typeof window === 'undefined') return localePriority;

  const locationFinal = url || window.location.pathname;

  const fromUrl = LANGUAGE_CODES.find(locale =>
    new RegExp(`^/marketplace/${locale}`, 'i').test(locationFinal)
  );

  return fromUrl || localePriority;
};

const getBrowserLocale = () => {
  if (typeof window === 'undefined') return false;

  const navigatorLocale =
    navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;

  // Extract the base language code, e.g., "en" from "en-US"
  const baseLang = navigatorLocale.split('-')[0];

  // Check if there is a full match or a base language match in your LANGUAGE_CODES list
  const exactMatch = LANGUAGE_CODES.find(
    code => code.toLowerCase() === navigatorLocale.toLowerCase()
  );
  const baseMatch = LANGUAGE_CODES.find(code =>
    code.toLowerCase().startsWith(baseLang.toLowerCase())
  );

  // Return the exact match, or the base match, or the default locale
  return exactMatch || baseMatch;
};

const getCookieLocale = () => {
  const lang = getCookie('language');

  if (!lang) {
    return undefined;
  }

  return LANGUAGE_CODES.find(code => code.toLowerCase() === lang.toLowerCase());
};
